import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Equipment } from '../../../shared/interfaces/equipment.interfaces';

const basePath = '/equipment/claim';

@Injectable({
  providedIn: 'root',
})

export class EquipmentClaimService {
  constructor(private http: HttpClient) { }

  searchForClaimEquipment(sn: string | number): Observable<Equipment> {
    const params = new HttpParams()
      .set('sn', sn)
    return this.http.get<Equipment>(`${basePath}`, { params });
  }

  claimEquipment(id: number | string, dealer_id: number | string): Observable<Equipment> {
    const body = {
      id: id,
      dealer_id: dealer_id,
    };
    return this.http.post<Equipment>(`${basePath}`, body);
  }
}
